import { Stack, TextField } from '@mui/material'
import CustomDialog from '../CustomDialog'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../store'
import { ChangeEvent, useState } from 'react'
import { updateFileName } from '../../services/filesService'
import { setShowUploadModal } from '../../actions/construction'
import {
  AttributeActionNames,
  AttributeResourceNames,
} from '../../models/AccessControl'
import { Can } from '../../utils/AbilityUtil'
import { createSelector } from '@reduxjs/toolkit'
import DisplayErrorPopup from '../DisplayError'

const selectedOrganizationSelector = createSelector(
  [(state: RootState) => state.organization],
  (organization) => organization.selectedOrganization,
)

const selectedFileSelector = createSelector(
  [(state: RootState) => state.organization],
  (organization) => organization.selectedFile,
)

const EditFile = (props: any) => {
  const { isOpen, handleClose } = props
  const selectedFile = useSelector(selectedFileSelector)
  const [fileName, setFileName] = useState<string>(selectedFile?.name!)
  console.log('selectedFile', selectedFile)
  console.log('fileName', fileName)
  const dispatch = useDispatch<any>()

  const handleSubmit = async () => {
    await dispatch(
      updateFileName({
        fileId: selectedFile?.id!,
        fileName: fileName!,
      }),
    ).unwrap()
    handleClose()
    dispatch(setShowUploadModal(true))
  }

  const handleFileNameChange = (event: ChangeEvent<HTMLInputElement>) => {
    setFileName(event.target.value)
  }

  return (
    <Can I={AttributeActionNames.Create} a={AttributeResourceNames.Files}>
      <CustomDialog
        isOpen={isOpen}
        title='Rename file'
        handleClose={() => {
          handleClose()
        }}
        handleSubmit={async () => await handleSubmit()}
      >
        <DisplayErrorPopup />
        <Stack rowGap={'18px'} sx={{ mb: '12px' }}>
          <TextField
            sx={{
              width: '389px',
              '& .MuiInputBase-input': {
                color: '#04002E',
                fontSize: '14px',
                lineHeight: 'normal',
              },
              '& .MuiOutlinedInput-root': {
                boxShadow: '0px 3px 10px 0px rgba(187, 187, 187, 0.25)',
              },
              '& .MuiInputBase-input::placeholder': {
                color: '#C3C3C3',
                opacity: 1,
                fontSize: '14px',
              },
            }}
            size='small'
            placeholder='Rename file'
            autoFocus
            required
            margin='dense'
            id='name'
            name='name'
            value={fileName}
            onChange={handleFileNameChange}
          />
        </Stack>
      </CustomDialog>
    </Can>
  )
}

export default EditFile
